import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const firebaseApp = getApps()[0] || initializeApp(firebaseConfig);
export const fbAuth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

const MESSAGES = {
  "auth/invalid-credential": "Incorrect email or password.",
  "auth/wrong-password": "Incorrect email or password.",
  "auth/user-not-found": "Incorrect email or password.",
  "auth/invalid-email": "Please enter a valid email address.",
  "auth/user-disabled": "This account has been disabled. Contact your TWIN administrator.",
  "auth/too-many-requests": "Too many attempts. Please wait a few minutes and try again.",
  "auth/email-already-in-use": "An account with this email already exists. Sign in instead.",
  "auth/weak-password": "Password must be at least 6 characters.",
  "auth/popup-closed-by-user": "Google sign-in was cancelled.",
  "auth/cancelled-popup-request": "Google sign-in was cancelled.",
  "auth/popup-blocked": "Your browser blocked the Google sign-in window. Allow pop-ups and try again.",
  "auth/network-request-failed": "Network error. Check your connection and try again.",
  "auth/invalid-verification-code": "That code is not correct. Try the latest code from your app.",
  "auth/requires-recent-login": "For security, please sign out and sign in again, then retry.",
  "auth/operation-not-allowed": "2-step verification has not been switched on for TWIN yet. Ask your platform owner.",
  "auth/admin-restricted-operation": "2-step verification has not been switched on for TWIN yet. Ask your platform owner.",
  "auth/account-exists-with-different-credential": "This email is already registered with a password. Sign in with email and password.",
};

export function firebaseErrorMessage(e) {
  return MESSAGES[e?.code] || e?.message || "Something went wrong. Please try again.";
}
